module.exports = __webpack_public_path__ + "media/images/icon-ban-3204686edc020e55b3294bd29eda8a1f.svg";